import React, { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import axios from "axios";
import API_BASE_URL from '../../api/config';

const TestimonialSlider = ({ collegeName }) => {
  const [testimonials, setTestimonials] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/team/read_isShown`);
        const arr = Array.isArray(res.data) ? res.data : (res.data.data || []);
        const filtered = arr.filter(
          (item) =>
            item.college?.toLowerCase() === collegeName?.toLowerCase()
        );
        setTestimonials(filtered);
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      }
    };

    fetchTestimonials();
  }, [collegeName]);

  const nextTestimonial = useCallback(() => {
    setIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  }, [testimonials.length]);

  const prevTestimonial = useCallback(() => {
    setIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  }, [testimonials.length]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowRight") nextTestimonial();
      else if (event.key === "ArrowLeft") prevTestimonial();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [nextTestimonial, prevTestimonial]);

  if (testimonials.length === 0) return null;

  return (
    <div className="testimonial-slider">
      <div className="testimonial-header">
        <h2 className="testimonial-title">Our Team</h2>
      </div>

      <motion.div
        className="testimonial-container"
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <button className="nav-btn left" onClick={prevTestimonial}>
          <FaArrowLeft />
        </button>

        <div className="testimonial-card">
          <AnimatePresence mode="wait">
            <motion.div
              key={testimonials[index].id}
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 50 }}
              transition={{ duration: 0.6 }}
              className="testimonial-content"
              drag="x"
              dragConstraints={{ left: 0, right: 0 }}
              onDragEnd={(e, info) => {
                if (info.offset.x > 100) {
                  prevTestimonial();
                } else if (info.offset.x < -100) {
                  nextTestimonial();
                }
              }}
            >
              <motion.img
                src={`https://ethiccraft.org/${testimonials[index].image}`}
                alt={testimonials[index].name}
                className="testimonial-image"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
              />
              <div className="testimonial-text-container">
                <p className="testimonial-text">
                  "{testimonials[index].description}"
                </p>
                <h3 className="testimonial-name">{testimonials[index].name}</h3>
                <p className="testimonial-role">{testimonials[index].designation}</p>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <button className="nav-btn right" onClick={nextTestimonial}>
          <FaArrowRight />
        </button>
      </motion.div>
    </div>
  );
};

export default TestimonialSlider;